import {connect} from 'react-redux';
import React, {Component} from 'react';
import Layout from './Base/Layout';

class PrivacyPolicyPage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {i18n} = this.props;

        let privacyPolicy = this.props.privacyPolicy;

        return (
            <Layout
                showPromoContent={false}
                title={i18n['privacyPolicyPage.title']}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc">
                        <a href="/" className="cancel">{i18n['service.feedback.back']}</a>

                        <div className="clearfix heading">
                            <h2>
                                {i18n['privacyPolicyPage.title']}
                            </h2>
                        </div>

                        <div dangerouslySetInnerHTML={{__html: privacyPolicy != null ? privacyPolicy : ''}}
                             style={{minHeight: '100px'}}></div>

                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    privacyPolicy: state.configuration.privacyPolicy,
    currentUser: state.user.currentUser,
    languageCode: state.languages.currentLanguage.code
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicyPage);



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicyPage.js